// extracted by mini-css-extract-plugin
module.exports = {"list-images":"list-images--2XUaX"};